'use client';

import { Link, SpriteIcon } from '@coolblue-development/freddy';
import selectAllAlternativesBelowElementTrigger from '@coolblue-development/ga4-events/triggers/OutOfStockEntrance/selectAllAlternativesBelowElementTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';

export const AllAlternativesLink = ({ url, title }: { url: string; title: string }) => {
  const { t } = useTranslation('webshop.productPage');
  const { trackEvent } = useAnalytics();

  const handleClick = () => {
    trackEvent(
      selectAllAlternativesBelowElementTrigger({
        content: title
      })
    );
  };

  return (
    <Link
      href={url}
      startIcon={<SpriteIcon name='arrow-right' />}
      onClick={handleClick}
      sx={{ alignSelf: 'flex-start' }}
    >
      {`${t('relatedProducts.bekijkAlle')} ${title}`}
    </Link>
  );
};
